interface FlattenAppearanceProps {
  appearance: string[] | string;
  styles: { [key: string]: string };
}

interface FlattenedAppearanceProps {
  [key: string]: boolean;
}

export const flattenAppearance = ({
  appearance,
  styles
}: FlattenAppearanceProps): FlattenedAppearanceProps | string => {
  if (Array.isArray(appearance)) {
    return appearance.reduce((a, i) => (styles[i] ? { ...a, [styles[i]]: true } : a), {});
  }
  return styles[appearance];
};
